import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { X } from 'lucide-react';
export function Objections() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank');
  };
  const objections = ['Experiencia', 'Mucho dinero', 'Ser experta en tecnología'];
  return <section className="bg-brand-beige py-20 px-6" data-id="element-193">
      <div className="max-w-3xl mx-auto text-center" data-id="element-194">
        <FadeIn data-id="element-195">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-green mb-4" data-id="element-196">
            No necesitas experiencia previa.
          </h2>
          <p className="text-lg text-brand-text/70 mb-12" data-id="element-197">
            Este sistema está diseñado para principiantes que quieren empezar
            desde cero, con una guía clara y sin complicaciones.
          </p>
        </FadeIn>

        <div className="flex flex-col md:flex-row justify-center gap-6 mb-16" data-id="element-198">
          {objections.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-199">
              <div className="bg-white px-8 py-4 rounded-full shadow-sm flex items-center justify-center gap-3 border border-brand-green/5" data-id="element-200">
                <div className="bg-red-50 rounded-full p-1" data-id="element-201">
                  <X className="w-5 h-5 text-red-500" data-id="element-202" />
                </div>
                <span className="text-lg font-medium text-brand-text" data-id="element-203">
                  {item}
                </span>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-204">
          <p className="text-2xl font-serif text-brand-green mb-10 flex items-center justify-center gap-3" data-id="element-205">
            <span data-id="element-206">👉</span> Solo necesitas empezar con una guía clara
          </p>
          <Button onClick={goToCheckout} data-id="element-207">SÍ, QUIERO EMPEZAR</Button>
        </FadeIn>
      </div>
    </section>;
}